<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'5'" [loanTypeId]="15"  serviceName="children marriage planning"></app-banner-enquiry-form>>

<div class="plan-section">
  <h2 class="plan-title">Investment Planning for Child Marriage</h2>
  <p class="plan-description">
    Child marriage is a deeply rooted social issue that affects millions of girls worldwide. It can have profound financial implications, particularly in regions where it is prevalent. Planning for a child's marriage involves careful financial foresight and strategy. As a Wealth Business Coach, I understand the importance of this and have outlined a detailed investment planning guide for child marriage.  </p>

  <h3 class="important-heading">
    Steps for successful Children Marriage Planning
  </h3>
  <div class="underline"></div>

  <!-- Service Sections -->
  <section class="service-section">
    <div class="content">
      <h2>Introduction</h2>
      <p>
       <strong>Child marriage</strong>  is a deeply rooted social issue that affects millions of girls worldwide. It can have profound financial implications, particularly in regions where it is prevalent. Planning for a child's marriage involves careful financial foresight and strategy. As a Wealth Business Coach, I understand the importance of this and have outlined a detailed investment planning guide for child marriage.
    </p>
    </div>
    <img src="assets/Services/fplanning.svg" alt="Financial Planning Introduction">
  </section>

  <section class="service-section">
    <div  class="order-md-1 order-2" >
      <img src="assets/Services/Budget.svg" alt="Understanding Financial Situation">

    </div>
    <div class="content order-md-2 order-1" >
      <h2>Understanding Your Financial Situation</h2>
      <p>
       <strong>Step 1:</strong>  Assess Current Financial Situation Before diving into investment planning, it's crucial to assess your current financial situation. Consider your income, expenses, assets, and liabilities. Determine how much you can allocate towards the child's marriage fund without jeopardizing your financial stability.      </p>
    </div>
  </section>

  <section class="service-section">
    <div class="content">
      <h2>Setting Financial Goals</h2>
      <p>
       <strong>Step 2:</strong> Set a Clear Goal Establish a clear goal for the child's marriage fund. Determine the desired amount you want to accumulate by the time your child is ready for marriage. This will serve as a benchmark for your investment planning.
    </p>
    </div>
    <div >
      <img src="assets/Services/fgoal.svg" alt="Setting Financial Goals">

    </div>
  </section>
<!-- Step 3 Section -->
<section class="service-section">
  <div class="order-md-1 order-2">
    <img src="assets/Services/fp.svg" alt="Developing a Financial Plan">
  </div>
  <div class="content order-md-2 order-1">
    <h2>Developing a Financial Plan</h2>
    <p>
      <strong>Step 3:</strong> Choose the Right Investment Options. For long-term goals like child marriage, consider investing in instruments that offer higher returns over time. Options include: <strong>Equity Mutual Funds</strong> for higher returns over the long term.
      <br><strong>Public Provident Fund (PPF):</strong> A tax-saving investment with a lock-in period of 15 years.
      <br><strong>Unit-Linked Insurance Plans (ULIPs):</strong> Provide dual benefits of insurance and investment.
      <br><strong>Sukanya Samriddhi Yojana:</strong> A government scheme for the girl child with attractive interest rates.
    </p>
  </div>
</section>
  <section class="service-section">
    <div class="content">
      <h2>Implementing and Monitoring Your Plan</h2>
      <p>
       <strong>Step 4:</strong>  Diversify Your Portfolio Diversification is key to managing risk. Spread your investments across different asset classes like equities, debt, and gold. This helps reduce the impact of market volatility on your portfolio.
    </p>
    </div>
    <img src="assets/Services/fd.svg" alt="Monitoring and Adjusting">
  </section>
</div>
<!-- Step 5 Section -->
<section class="service-section">
  <div class="order-md-1 order-2">
    <img src="assets/Services/fp.svg" alt="Regularly Monitor and Review">
  </div>
  <div class="content order-md-2 order-1">
    <h2>Regularly Monitor and Review</h2>
    <p>
      <strong>Step 5:</strong> Regularly monitor your investments to ensure they align with your goals and risk tolerance. Review your portfolio periodically and make necessary adjustments to stay on track.
    </p>
  </div>
</section>


  <section class="service-section">
    <div class="content">
      <h2>Implementing and Monitoring Your Plan</h2>
      <p>
        <strong>Step 6:</strong> Stay Disciplined Investing for child marriage is a long-term commitment. Stay disciplined and continue investing regularly, even during market fluctuations. Compounding will work in your Favor over time.
    </p>
    </div>
    <img src="assets/Services/fd.svg" alt="Monitoring and Adjusting">
  </section>

  <section class="contact-us-section">
    <div class="contact-content">
      <h2>Contact Us  Today!</h2>
      <p class="slogan">Your journey to financial freedom starts here!</p>
    </div>

    <div class="contact-form-container">
      <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
        <h2>Submit Your Enquiry</h2>
        <input formControlName="full_name" type="text" placeholder="Your Name" required>
        <input formControlName="email" type="email" placeholder="Your Email" required>
        <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
        <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
        <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
        <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
      </form>

      <!-- Standard message after submission -->

    <!-- Thank you message with animated smiley -->
    <div *ngIf="isEnquirySubmitted" class="card mb-3">
      <div class="card-body text-center">
        <h3 class="card-title">
          Thank you for your enquiry! We will get back to you shortly!
          <span class="smiley"></span>
        </h3>
      </div>
    </div>

    </div>

  </section>

<app-footer></app-footer>
